import React from 'react';

interface ITab {
    title: string | React.ReactElement;
    children: React.ReactElement;
}

export const Tab: React.FC<ITab> = ({ children }) => {
    return <div>{children}</div>;
};
